import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { InfiniteScrollStore } from '../../../../shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { getServiceProcedureFrag } from './voucher-detail-prescriptions-medical-procedures.query';
import { selectCurrentServiceId } from '../../../store/person/person.selectors';

@Injectable()
export class VoucherDetailPrescriptionsMedicalProceduresStore extends ComponentStoreV2Factory {

    public serviceId = this.store.selectSignal(selectCurrentServiceId);

    public isContinuous = computed(() => {
        return (this.data.getServiceOperationalCapacities()?.items?.length || 0) > 0;
    });

    public proceduresScroll = computed(() => {
        return new InfiniteScrollStore(
            this.api.getServiceMedicalProcedures,
            FilterBuilder.filter({
                limit: 100,
                serviceId: this.serviceId(),
                active: true,
            }),
            true,
            getServiceProcedureFrag,
            (items) => items.map((it: any) => ({
                ...it,
                description: it.description || it.procedure?.description || '',
            })),
        );
    });

}
